import { RezerwaContext } from "../../../context/rezerwaContext";
import { useContext } from "react";
import LineSpacer from "../../../components/LineSpacer";
import { Button, Input, Select } from "antd";
import CalculatorInput from "../../../components/CalculatorInput";
import { useState } from "react";
import BankAccountInput from "../../../components/BankAccountInput";
import FixedNumberInput from "../../../components/FixedNumberInput";
import Label from "../../../components/Label";
import { useAuth } from "../../../context/AuthContext";
import axios from "../../../context/axiosConfig";
import isCan from "../../../components/isCan";
import { useEffect } from "react";
import {
	buildTransferTitlePreview,
	sanitizeSingleLineTitle,
} from "../../../components/transferTitleUtils";

const Transfer = ({ selectedPerson, transfer, index, total }) => {
	const { rezerwa, setrezerwa } = useContext(RezerwaContext);
	const [open, setOpen] = useState(true);
	const { user } = useAuth();
	const perms = user.perms;
	const [cando, setCando] = useState(false);
	const isDisabled =
		rezerwa.mode === "preview" ||
		transfer.msr_generated_files_id ||
		transfer.msr_transfers_confirmed;

	const accountDigits = (
		transfer?.msr_transfers_account_number || ""
	).replace(/\s+/g, "");
	const isBankAccountValid = /^\d{26}$/.test(accountDigits);
	const confirmDisabled =
		transfer.msr_transfers_amount &&
		transfer.msr_transfers_amount != 0 &&
		(transfer.msr_transfers_types_bank_transfer == 1
			? transfer.msr_transfers_account_number != "" &&
				transfer.msr_transfers_account_number != 0 &&
				transfer.msr_transfers_account_number &&
				transfer.msr_transfers_account_owner != "" &&
				isBankAccountValid
			: true);
	const autoTransferTitle = buildTransferTitlePreview({
		personName: selectedPerson.msr_persons_name,
		personLastName: selectedPerson.msr_persons_lastname,
		wplywOwnId: rezerwa?.rezerwa_data?.data?.rezerwa?.msr_wplywy_own_id,
		personOwnId: selectedPerson.msr_persons_own_id,
		transferOwnId: transfer.msr_transfers_own_id,
		titleSuffix: transfer.msr_transfers_title_suffix,
	});
	const transfertitle = buildTransferTitlePreview({
		personName: selectedPerson.msr_persons_name,
		personLastName: selectedPerson.msr_persons_lastname,
		wplywOwnId: rezerwa?.rezerwa_data?.data?.rezerwa?.msr_wplywy_own_id,
		personOwnId: selectedPerson.msr_persons_own_id,
		transferOwnId: transfer.msr_transfers_own_id,
		titleSuffix: transfer.msr_transfers_title_suffix,
		customTitle: transfer.msr_transfers_title,
	});

	const labelStyle = {
		color: "black",
		fontWeight: "500",
		fontSize: "16px",
		marginBottom: "8px",
	};
	const valueStyle = {
		color: "black",
		fontWeight: "700",
		fontSize: "16px",
	};

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			let requiredPerms = ["can_confirm_transfers"];
			const result = await isCan(requiredPerms, perms);
			setCando(result);
		};
		fetchPermissions();
	}, [perms]);

	const checkValues = (field, value) => {
		switch (field) {
			case "msr_transfers_types_id":
				return rezerwa?.rezerwa_data?.data?.default_values.msr_transfers_types.find(
					(x) => x.value === value,
				).label;
			default:
				return value;
		}
	};

	const ConfirmTransfer = async () => {
		try {
			const response = await axios.post("/wplyw/confirm/transfer", {
				transferid: transfer.msr_transfers_id,
				userid: user.user.mlg_users_id,
			});
			setrezerwa({ ...rezerwa, reload: !rezerwa.reload });
		} catch (error) {
			console.error("Error confirming transfer:", error);
		}
	};
	const UnconfirmTransfer = async () => {
		try {
			const response = await axios.post("/wplyw/unconfirm/transfer", {
				transferid: transfer.msr_transfers_id,
				userid: user.user.mlg_users_id,
			});
			setrezerwa({ ...rezerwa, reload: !rezerwa.reload });
		} catch (error) {
			console.error("Error confirming transfer:", error);
		}
	};

	const handleUpdateTransfer = (key, value) => {
		const fieldLabels = {
			msr_transfers_amount: "Kwota przelewu",
			msr_transfers_account_number: "Numer konta bankowego",
			msr_transfers_account_owner: "Właściciel konta",
			msr_transfers_title: "Nazwa przelewu",
			msr_transfers_title_suffix: "Sufiks tytułu przelewu",
			msr_transfers_description: "Opis przelewu",
			msr_transfers_types_id: "Typ przelewu",
		};

		const sanitizedValue =
			key === "msr_transfers_title_suffix" ||
			key === "msr_transfers_title"
				? sanitizeSingleLineTitle(value)
				: value;
		const updatedTransfer = { ...transfer, [key]: sanitizedValue };
		const nextTitle = buildTransferTitlePreview({
			personName: selectedPerson.msr_persons_name,
			personLastName: selectedPerson.msr_persons_lastname,
			wplywOwnId: rezerwa?.rezerwa_data?.data?.rezerwa.msr_wplywy_own_id,
			personOwnId: selectedPerson.msr_persons_own_id,
			transferOwnId: transfer.msr_transfers_own_id,
			titleSuffix: updatedTransfer?.msr_transfers_title_suffix,
			customTitle: updatedTransfer?.msr_transfers_title,
		});

		if (
			nextTitle.length > 140 &&
			(key === "msr_transfers_title_suffix" ||
				key === "msr_transfers_title")
		) {
			return;
		}

		setrezerwa((prev) => {
			const updatedTransfers = selectedPerson.msr_transfers.map((t) =>
				t.msr_transfers_id === transfer.msr_transfers_id
					? { ...t, [key]: sanitizedValue }
					: t,
			);

			const changes = [...(prev.changes || [])];
			const existingChangeIndex = changes.findIndex(
				(change) =>
					change.field === key &&
					change.objectid === transfer.msr_transfers_own_id,
			);
			const originalValue = transfer[key];
			if (existingChangeIndex > -1) {
				changes[existingChangeIndex] = {
					...changes[existingChangeIndex],
					newValue: checkValues(key, sanitizedValue),
					datetime: Math.floor(new Date().getTime() / 1000),
				};
			} else {
				changes.push({
					etap: "Przelew",
					field: key,
					label: fieldLabels[key] || key,
					action: "edit",
					oldValue: originalValue,
					newValue: checkValues(key, sanitizedValue),
					datetime: Math.floor(new Date().getTime() / 1000),
					user: user.user.mlg_users_id,
					objectid: transfer.msr_transfers_own_id,
					wplywid:
						rezerwa?.rezerwa_data?.data?.rezerwa.msr_wplywy_own_id,
					personid: selectedPerson.msr_persons_own_id,
				});
			}

			return {
				...prev,
				rezerwa_data: {
					...prev.rezerwa_data,
					data: {
						...prev.rezerwa_data?.data,
						rezerwa: {
							...prev.rezerwa_data?.data?.rezerwa,
							msr_transfers: updatedTransfers,
						},
					},
				},
				changes,
			};
		});
	};

	const handleRemoveTransfer = () => {
		setrezerwa((prev) => {
			const updatedTransfers = selectedPerson.msr_transfers.filter(
				(t) => t.msr_transfers_id !== transfer.msr_transfers_id,
			);

			const changes = [...(prev.changes || [])];

			changes.push({
				etap: "Przelew",
				field: "msr_transfers",
				label: "Usunięcie przelewu",
				action: "remove",
				oldValue: `Usunięto przelew o ID ${transfer.msr_transfers_own_id}`,
				newValue: `Usunięto przelew o ID ${transfer.msr_transfers_own_id}`,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: transfer.msr_transfers_own_id,
				wplywid: rezerwa?.rezerwa_data?.data?.rezerwa.msr_wplywy_own_id,
				personid: selectedPerson.msr_persons_own_id,
			});
			return {
				...prev,
				rezerwa_data: {
					...prev.rezerwa_data,
					data: {
						...prev.rezerwa_data?.data,
						rezerwa: {
							...prev.rezerwa_data?.data?.rezerwa,
							msr_transfers: updatedTransfers,
						},
					},
				},
				changes,
			};
		});
	};

	const isBankTransfer =
		rezerwa?.rezerwa_data?.data?.default_values?.msr_transfers_types.find(
			(x) => x.msr_transfers_types_id === transfer.msr_transfers_types_id,
		)?.msr_transfers_types_bank_transfer === 1;

	return (
		<div
			style={{
				background: "white",
				padding: "0",
				borderRadius: "5px",
				border: `1px solid ${
					transfer.msr_generated_files_id
						? "rgb(82, 196, 26)"
						: "rgb(189, 129, 54)"
				}`,
				marginBottom: "20px",
			}}
		>
			<div
				style={{
					padding: "20px",
					opacity: transfer.msr_generated_files_id ? "0.4" : "1",
				}}
			>
				<div
					style={{
						display: "flex",
						gap: "20px",
						alignItems: "center",
					}}
				>
					<div
						style={{
							background: "black",
							color: "white",
							padding: "7px 15px",
							fontSize: "16px",
							width: "fit-content",
							borderRadius: "5px",
						}}
					>
						#{index + 1} Wypłata #{transfer?.msr_transfers_own_id}
					</div>
					<LineSpacer />
					<Button onClick={() => setOpen(!open)}>
						{open ? "Zwiń" : "Rozwiń"}
					</Button>
					{!isDisabled && (
						<Button
							onClick={handleRemoveTransfer}
							danger
						>
							Usuń wypłatę
						</Button>
					)}
					{confirmDisabled && (
						<div
							style={{
								display: "flex",
								gap: "16px",
								justifyContent: "end",
							}}
						>
							{transfer.msr_generated_files_id || !cando ? (
								<></>
							) : !transfer.msr_transfers_confirmed ? (
								!(transfer.msr_transfers_id || "")
									.toString()
									.includes("temp") ? (
									<Button onClick={() => ConfirmTransfer()}>
										Zatwierdź przelew
									</Button>
								) : (
									<Button warning>
										Zapisz wpływ aby zatwierdzić przelew
									</Button>
								)
							) : (
								<Button onClick={() => UnconfirmTransfer()}>
									Cofnij zatwierdzenie przelew
								</Button>
							)}
						</div>
					)}
				</div>
				{open && (
					<>
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "1fr 1fr 150px",
								alignItems: "end",
								gap: "32px",
								marginTop: "16px",
							}}
						>
							<div>
								<Label required>
									{
										rezerwa?.rezerwa_data?.data?.default_values?.msr_transfers_types.find(
											(x) =>
												x.msr_transfers_types_id ===
												transfer.msr_transfers_types_id,
										)?.msr_transfers_types_amount_title
									}
								</Label>
								<FixedNumberInput
									mode={rezerwa.mode}
									disabled={isDisabled}
									calculator={true}
									maxvalue={
										total -
										selectedPerson.msr_transfers.reduce(
											(sum, tr) =>
												sum +
												(tr.msr_transfers_id !=
												transfer.msr_transfers_id
													? parseFloat(
															tr.msr_transfers_amount,
														)
													: 0),
											0,
										)
									}
									value={transfer.msr_transfers_amount}
									onChange={(e) =>
										handleUpdateTransfer(
											"msr_transfers_amount",
											e,
										)
									}
									addonAfter="zł"
								/>
							</div>
							<div>
								<Label required>Przedmiot kwoty wpływu</Label>
								<Select
									style={{ width: "100%" }}
									disabled={isDisabled}
									value={
										transfer.msr_transfers_types_id || ""
									}
									options={
										rezerwa?.rezerwa_data?.data
											?.default_values
											?.msr_transfers_types || []
									}
									onChange={(value) =>
										handleUpdateTransfer(
											"msr_transfers_types_id",
											value,
										)
									}
								/>
							</div>
						</div>
						{isBankTransfer && (
							<>
								<div
									style={{
										display: "grid",
										gridTemplateColumns: "1fr 1fr 1fr",
										alignItems: "end",
										gap: "32px",
										marginTop: "16px",
									}}
								>
									<div>
										<Label required>
											Numer konta bankowego
										</Label>
										<BankAccountInput
											disabled={isDisabled}
											value={
												transfer.msr_transfers_account_number ||
												""
											}
											onChange={(formattedValue) =>
												handleUpdateTransfer(
													"msr_transfers_account_number",
													formattedValue,
												)
											}
										/>
									</div>
									<div>
										<Label required>
											Imię i nazwisko właściciela konta
										</Label>
										<div
											style={{
												display: "flex",
												gap: "8px",
											}}
										>
											<Input
												status={
													transfer.msr_transfers_account_owner !=
													""
														? "default"
														: "error"
												}
												disabled={isDisabled}
												value={
													transfer.msr_transfers_account_owner ||
													""
												}
												onChange={(e) =>
													handleUpdateTransfer(
														"msr_transfers_account_owner",
														e.target.value,
													)
												}
											/>
											<Button
												style={{ height: "35px" }}
												onClick={() =>
													handleUpdateTransfer(
														"msr_transfers_account_owner",
														`${selectedPerson.msr_persons_name} ${selectedPerson.msr_persons_lastname}`,
													)
												}
												disabled={isDisabled}
											>
												Kopiuj dane osoby
											</Button>
										</div>
									</div>
									<div>
										<div style={labelStyle}>
											Sufiks do tytułu przelewu
										</div>
										<Input
											disabled={isDisabled}
											value={
												transfer.msr_transfers_title_suffix ||
												""
											}
											onChange={(e) =>
												handleUpdateTransfer(
													"msr_transfers_title_suffix",
													e.target.value,
												)
											}
										/>
									</div>
								</div>
								<div
									style={{
										display: "grid",
										gridTemplateColumns: "1fr 1fr",
										alignItems: "start",
										gap: "32px",
										marginTop: "16px",
									}}
								>
									<div>
										<div style={labelStyle}>
											Nazwa przelewu
										</div>
										<Input
											disabled={isDisabled}
											placeholder="(opcjonalnie)"
											value={
												transfer.msr_transfers_title ||
												""
											}
											onChange={(e) =>
												handleUpdateTransfer(
													"msr_transfers_title",
													e.target.value,
												)
											}
										/>
										<div
											style={{
												opacity: 0.6,
												marginTop: 6,
											}}
										>
											Jeśli puste, tytuł generuje się
											automatycznie.
										</div>
										<div
											style={{
												opacity: 0.6,
												marginTop: 6,
											}}
										>
											Limit: 140 znaków (łącznie z
											sufiksem).
										</div>
									</div>
									<div>
										<div style={labelStyle}>Opis</div>
										<Input.TextArea
											disabled={isDisabled}
											autoSize={{
												minRows: 2,
												maxRows: 6,
											}}
											value={
												transfer.msr_transfers_description ||
												""
											}
											onChange={(e) =>
												handleUpdateTransfer(
													"msr_transfers_description",
													e.target.value,
												)
											}
										/>
									</div>
								</div>
								<div
									style={{
										display: "grid",
										gridTemplateColumns: "1fr",
										alignItems: "end",
										gap: "32px",
										marginTop: "16px",
									}}
								>
									<div>
										<div style={labelStyle}>
											Tytuł przelewu
										</div>
										<div style={valueStyle}>
											{transfertitle}
										</div>
										{transfer?.msr_transfers_title ? (
											<div
												style={{
													opacity: 0.6,
													marginTop: 6,
												}}
											>
												Auto: {autoTransferTitle}
											</div>
										) : null}
									</div>
								</div>
							</>
						)}
					</>
				)}
			</div>
			{transfer.msr_generated_files_id ? (
				<>
					<div
						style={{
							background: "rgb(82, 196, 26)",
							color: "white",
							padding: "10px 20px",
							textAlign: "center",
							marginTop: "20px",
						}}
					>
						Przelew wygenerowany - nie można edytować
					</div>
				</>
			) : (
				<></>
			)}
			{transfer.msr_transfers_confirmed &&
			!transfer.msr_generated_files_id ? (
				<>
					<div
						style={{
							background: "#bd8136",
							color: "white",
							padding: "10px 20px",
							textAlign: "center",
							marginTop: "20px",
						}}
					>
						Przelew zatwierdzono - nie można edytować
					</div>
				</>
			) : (
				<></>
			)}
		</div>
	);
};

export default Transfer;
